import store from "../store";

const axios = require("axios");

export const SAVE_SUCCESS = "SAVE_SUCCESS";
export const SAVE_ERROR = "SAVE_ERROR";
export const SAVE_START = "SAVE_START";
export const RESET = "RESET";
export const GET_GAME = "GET_GAME";
export const GAME_SUCCESS = "GAME_SUCCESS";

export const saveStart = () => {
  return {
    type: SAVE_START
  };
};

export const saveGame = (idUsuario, puntaje, tiempo) => {
  return dispatch => {
    if (
      !store.getState().gameReducer.isSaving &&
      !store.getState().gameReducer.isSaved
    ) {
      dispatch(saveStart());

      return axios
        .post("http://190.105.227.203/memory/partidas", {
          idusuario: idUsuario,
          puntaje: puntaje,
          tiempo: tiempo
        })
        .then(response => {
          console.log(response);
          if (response.data.data.affectedRows == 1) {
            dispatch(saveGameSuccess());
          } else {
            dispatch(saveGameError({ error: "error" }));
          }
        })
        .catch(error => {});
    }
  };
};

export const getGame = () => {
  return dispatch => {
    return axios
      .get("http://190.105.227.203/memory/partidas")
      .then(response => {
        dispatch(getGameSuccess(response.data["data"][0]));
      })
      .catch(error => {});
  };
};

export const getGameSuccess = response => {
  return {
    type: GAME_SUCCESS,
    response: response
  };
};

export const saveGameSuccess = () => {
  return {
    type: SAVE_SUCCESS
  };
};

export const saveGameError = () => {
  return {
    type: SAVE_ERROR
  };
};

export const resetGame = () => {
  return {
    type: RESET
  };
};
